import { render } from "./Likes.vue?vue&type=template&id=dbdf613a&ts=true"
import script from "./Likes.vue?vue&type=script&lang=ts"
export * from "./Likes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__